/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ForgeFooter.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : 
 *
 * On            : 
 *
 * @Version      : Version 1.0
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Mar 19, 2019
 * Description   : ASDS-2443: Added Forge header and footer
 * 
 * By            : H224423
 * On            : Mar 23, 2019
 * Description   : ASDS-1052 Separated Footer code to separate component.
 * 
 ******************************************************************************/

import * as React from 'react';
import { Footer } from '@scuf/common';
import { connect } from 'react-redux';
import privacyImage from "./ccpa-privacyoptions.svg";

function ForgeFooter (props:any){
    return (
        <React.Fragment>
        {props.fullName &&
        (<Footer copyrightText="">
        <Footer.Item className="inactiveLink">Copyright © 2020 Honeywell International Inc.</Footer.Item>
        <Footer.Item href="https://www.honeywellaerospace.com/en-us/terms-and-conditions" target="_blank">Terms &amp; Conditions</Footer.Item>
        <Footer.Item href="https://www.honeywellaerospace.com/en-us/privacy-statement" target="_blank">Privacy Statement</Footer.Item> 
        <Footer.Item href="https://hon-opcenter.my.salesforce-sites.com/PrivacyInformationRequestForm?lang=en" target="_blank">
            Your Privacy Choices &nbsp;
            <img src={privacyImage} className="optanon-category-C0004 footer-icon" alt="icon"/>
        </Footer.Item>
        <Footer.Item href="https://www.honeywellaerospace.com/en/redirects/external/cookies" target="_blank">Cookies</Footer.Item>   
        <Footer.Item href="https://www.honeywellaerospace.com/en/redirects/external/global-unsubscribe" target="_blank">Global Unsubscribe</Footer.Item>  
        </Footer>
        )
        }
        </React.Fragment>
    );
    }

function mapStateToProps(state) {
    return {
        fullName : state.userValidationData.payload.userInfo.name,
    };
}

export default connect(mapStateToProps)(ForgeFooter);